import React from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";


function AppButton({ children, variant, className = "", color, row = false, ...props }) {
  let btnClass = "app-btn ";
  if (variant === "back") btnClass += "app-btn-back ";
  if (variant === "next") btnClass += "app-btn-next ";
  btnClass += className;

  // Default colors
  let defaultColor = undefined;
  let defaultTextColor = undefined;
  if (!color) {
    if (variant === "back") {
      defaultColor = "#6b7280"; // gray
      defaultTextColor = "#fff";
    } else if (variant === "next") {
      defaultColor = "#FB9C0C"; // maya blue
      defaultTextColor = "#fff";
    }
  }

  const style = {
    padding: "1rem 2rem",
    fontSize: "1rem",
    fontWeight: 600,
    borderRadius: "12px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    border: "none",
    background: color || defaultColor,
    borderColor: color || defaultColor,
    color: defaultTextColor,
    ...props.style,
  };


  return (
    <Button className={btnClass.trim()} {...props} style={style}>
      {children}
    </Button>
  );
}


AppButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["back", "next"]),
  className: PropTypes.string,
  color: PropTypes.string,
  row: PropTypes.bool,
};

export default AppButton;
